module.exports = __webpack_public_path__ + "static/img/2019092409082220.8605b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2019092409082220.png
// module id = nb+N
// module chunks = 1